export default __webpack_public_path__ + "static/media/ice.a2369f6d.svg";